import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PrefState {
    [key: string]: any;
};

const initialState: PrefState = {};

export const prefSlice = createSlice({
    name: 'pref',
    initialState,
    reducers: {
        setPref: (state, action: PayloadAction<{ key: string; value: any }>) => {
            const { key, value } = action.payload;
            // Use bracket notation to set the value for the given key
            state[key] = value;
          },
    }
});

export const { setPref } = prefSlice.actions;
export default prefSlice.reducer;
